<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  <app-page-hero
    eyebrow="Warehousing"
    title="Generate Billing Draft"
    subtitle="Calculate SQM/CBM storage charges from warehouse occupancy, then edit before posting."
    backLink="/warehousing/billing-drafts">
    <div actions>
      <p-button label="Generate Draft" icon="pi pi-bolt" severity="warn" type="button" [loading]="isLoading" [disabled]="isLoading" (click)="generateBillingDraft()"></p-button>
    </div>
  </app-page-hero>

  <form [formGroup]="billingForm" (ngSubmit)="generateBillingDraft()" class="warehousing-form-grid p-fluid">
    <app-page-form-section icon="pi pi-wallet" title="Billing Scope" subtitle="Choose the client, optional account, billing period, and draft currency.">
      <div class="formgrid grid">
        <div class="field col-12">
          <app-commercial-party-picker
            [owningCompanyId]="owningCompanyId"
            [value]="commercialPartyReference"
            [required]="true"
            label="Warehouse Billing Party"
            (valueChange)="onCommercialPartyChange($event)">
          </app-commercial-party-picker>
        </div>
        <div class="field col-12 md:col-4"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel><input id="billingStartDate" pInputText type="date" formControlName="billingStartDate"><label for="billingStartDate">Start Date</label></p-iftaLabel></p-inputGroup></div>
        <div class="field col-12 md:col-4"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel><input id="billingEndDate" pInputText type="date" formControlName="billingEndDate"><label for="billingEndDate">End Date</label></p-iftaLabel></p-inputGroup></div>
        <div class="field col-12 md:col-4"><p-inputGroup><p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon><p-iftaLabel><input id="currency" pInputText formControlName="currency"><label for="currency">Currency</label></p-iftaLabel></p-inputGroup></div>
        <div class="field col-12"><p-inputGroup><p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon><p-iftaLabel><textarea id="notes" pInputTextarea formControlName="notes" rows="3"></textarea><label for="notes">Draft Notes</label></p-iftaLabel></p-inputGroup></div>
      </div>
    </app-page-form-section>
  </form>
</app-page-shell>
